import classNames from 'classnames';
import { FC, PropsWithChildren, RefObject, UIEventHandler } from 'react';

import { customScrollStyles } from '@gem/ui-kit';

import styles from './MessagesContentWrapper.styles.m.css';

interface IMessagesContentWrapperProps {
  onScroll: UIEventHandler<HTMLDivElement>;
  scrollRef: RefObject<HTMLDivElement>;
}

export const MessagesContentWrapper: FC<PropsWithChildren<IMessagesContentWrapperProps>> = (
  props
) => {
  const { children, onScroll, scrollRef } = props;
  const containerClassNames = classNames(styles.messages, customScrollStyles.container);

  return (
    <div
      className={containerClassNames}
      id={'messages-container'}
      data-test={'messages-container'}
      ref={scrollRef}
      onScroll={onScroll}
    >
      {children}
    </div>
  );
};
